import { k453Notes } from "./k453Notes";
import { k405Notes } from "./k405Notes";
import { k453Summary, k405Summary } from "./summaries";
import { k453Cards, k405Cards } from "./flashcards";
import { k453Exams } from "./k453Exams";
import { k405Exams } from "./k405Exams";
import { k453Exam3 } from "./k453Exam3";
import { k405Exam3 } from "./k405Exam3";

// Şıkları deterministik olarak karıştır (doğru cevap dağılımı dengeli olsun; her yüklemede aynı sıra)
const hash = (s) => { let h = 2166136261; for (let i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 16777619); } return h >>> 0; };
const rng = (seed) => () => { seed |= 0; seed = (seed + 0x6d2b79f5) | 0; let t = Math.imul(seed ^ (seed >>> 15), 1 | seed); t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t; return ((t ^ (t >>> 14)) >>> 0) / 4294967296; };
const shuffleExams = (exams) =>
  exams.map((ex) => ({
    ...ex,
    questions: ex.questions.map((q, qi) => {
      const r = rng(hash(`${ex.id}-${qi}`));
      const perm = q.o.map((_, i) => i);
      for (let i = perm.length - 1; i > 0; i--) { const j = Math.floor(r() * (i + 1)); [perm[i], perm[j]] = [perm[j], perm[i]]; }
      const n = {};
      if (q.n) Object.entries(q.n).forEach(([k, v]) => { n[perm.indexOf(Number(k))] = v; });
      return { ...q, o: perm.map((j) => q.o[j]), a: perm.indexOf(q.a), n };
    }),
  }));

export const COURSES = {
  k453: {
    key: "k453",
    code: "KİMÖ-453",
    name: "Kimya ve Teknoloji",
    short: "Kimya & Teknoloji",
    notes: k453Notes,
    summary: k453Summary,
    cards: k453Cards,
    exams: shuffleExams([...k453Exams, k453Exam3]),
    tool: { key: "tool", label: "Sertlik Hesaplayıcı" },
  },
  k405: {
    key: "k405",
    code: "KİMÖ-405",
    name: "Kimya Dersi Öğretim Programları",
    short: "Öğretim Programları",
    notes: k405Notes,
    summary: k405Summary,
    cards: k405Cards,
    exams: shuffleExams([...k405Exams, k405Exam3]),
    tool: { key: "tool", label: "Beceri Mini Testi" },
  },
};

export const findQuestion = (examId) => {
  for (const c of Object.values(COURSES)) {
    const ex = c.exams.find((e) => e.id === examId);
    if (ex) return { course: c, exam: ex };
  }
  return null;
};
